export const FETCH = 'FETCH';
export const START = 'START';
export const SUCCES = 'SUCCESS';
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN';
export const SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE';